import { User } from './user';

export class ParkingBaySection {
  name!: string;
  description?: string;
  number_of_parking_bays!: number;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  occupied_parking_bays?: number;
  vacant_parking_bays?: number;



  user?: User;

  static getSortColumns() {
    return [
      'name',
      'description',
      'number_of_parking_bays',
      'status',
    ];
  }


  constructor(data: any) {
    this.user_uuid = data.user_uuid;
    this.name = data.name;
    this.description = data.description;
    this.number_of_parking_bays = data.number_of_parking_bays;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    this.occupied_parking_bays = data.occupied_parking_bays;
    this.vacant_parking_bays = data.vacant_parking_bays;


    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
